import { uniq } from 'lodash';

import { useLegacyBenefitProposalWorkflowTableData } from '~/data/proposals/useGetLegacyProposalWorkflows';

import { useBenefitProposalColumns } from '../../../../common';
import {
  ProposalWorkflowTablePropsType,
  ProposalsWorkflowTableLayout,
} from '../common';

export const BenefitProposalWorkflowTable = (
  props: ProposalWorkflowTablePropsType,
) => {
  const { data: rows } = useLegacyBenefitProposalWorkflowTableData(props);
  const columns = useBenefitProposalColumns({
    employmentIds: uniq(rows.map((r) => r.fEmplId)),
  });

  return <ProposalsWorkflowTableLayout rows={rows} columns={columns} />;
};
